module.exports = __webpack_public_path__ + "img/ic24Uname.5c89bf6b.svg";